import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText
} from '@mui/material';

import { styled } from '@mui/material/styles';
import { IListItem, IMenuItems } from './utils/interfaces';

const SidebarTitle = styled('div')(({ theme }) => ({
  fontSize: theme.typography.fontSize,
  fontFamily: theme.typography.fontFamily,
  color: theme.palette.secondary.dark
}));

interface IDrawerData {
  menuItem: IMenuItems;
  isOpen: boolean;
}

const DrawerItems: React.FC<IDrawerData> = ({
  menuItem,
  isOpen
}): JSX.Element => {
  const menuData = menuItem;
  const location = useLocation();
  const pathd = location.pathname;
  const id = getIdFromPath(pathd);
  const [selectedIndex, setSelectedIndex] = useState(id);
  const navigate = useNavigate();
  const isSidebarOpen = isOpen;
  function handleClickMenuItem(path: string, index: string): void {
    setSelectedIndex(index);
    navigate(path);
  }
  function getIdFromPath(path: string): string | undefined {
    if (path === '/') {
      return 'dashboard-btn'; // default has set to all members --> for dashboard set to 'dashboard-btn'
    }
    for (const key in menuItem) {
      const items = menuItem[key];
      const itemt = items.find((item) => item.path === path);
      if (itemt) {
        return itemt.permissionGroup;
      }
    }
    return undefined;
  }

  return (
    <React.Fragment>
      {Object.keys(menuData).map((key, i) => (
        <div key={key} style={{ marginTop: '10px' }}>
          {isSidebarOpen && key !== '' && (
            <SidebarTitle
              sx={{
                padding: '8px',
                marginLeft: '24px',
                height: '56px'
              }}
            >
              <ListItemText primary={key} />
            </SidebarTitle>
          )}

          {menuData[key].map((item: IListItem) => (
            <ListItem
              key={item.permissionGroup}
              style={{ paddingTop: 1, paddingBottom: 0 }}
            >
              <ListItemButton
                id={item.permissionGroup}
                onClick={() =>
                  handleClickMenuItem(item.path, item.permissionGroup)
                }
                selected={selectedIndex === item.permissionGroup}
                style={{
                  backgroundColor:
                    selectedIndex === item.permissionGroup ? '#D7E2FF' : ''
                }}
                sx={{
                  borderRadius: 28,
                  height: '56px',
                  ':hover': {
                    backgroundColor: 'secondary.light'
                  }
                }}
              >
                <ListItemIcon sx={{ minWidth: '10px', margin: 0 }}>
                  {item.icon}
                </ListItemIcon>
                {isSidebarOpen && (
                  <ListItemText
                    primary={item.title}
                    sx={{ marginLeft: '10px' }}
                  />
                )}
              </ListItemButton>
            </ListItem>
          ))}
          {!(i === Object.keys(menuData).length - 1) && !(i === 0) && (
            <Divider
              sx={{
                width: '250px',
                marginLeft: 'auto',
                marginRight: 'auto',
                marginTop: '5px'
              }}
            />
          )}
        </div>
      ))}
    </React.Fragment>
  );
};

export default DrawerItems;
